import { EmptyTemplatesStateTypes } from "./EmptyTemplatesState.types";
import { Template } from "@zapier/client";

interface UseShowEmptyTemplatesTableProps {
  templates?: Template[];
  isLoading: boolean;
  isFiltered?: boolean;
  shared?: string | null;
}

export function useShowEmptyTemplatesTable({
  templates,
  isLoading,
  isFiltered,
  shared,
}: UseShowEmptyTemplatesTableProps) {
  if (isLoading) {
    return {
      showEmptyState: false,
      emptyType: undefined,
    };
  }

  const hasTemplates = templates && templates.length > 0;

  if (hasTemplates) {
    return {
      showEmptyState: false,
      emptyType: undefined,
    };
  }

  // Determine empty state type based on filters
  if (isFiltered) {
    return {
      showEmptyState: true,
      emptyType: EmptyTemplatesStateTypes.EmptySearch,
    };
  }

  if (shared === "me") {
    return {
      showEmptyState: true,
      emptyType: EmptyTemplatesStateTypes.NoOwned,
    };
  }

  if (shared === "-me") {
    return {
      showEmptyState: true,
      emptyType: EmptyTemplatesStateTypes.NoShared,
    };
  }

  return {
    showEmptyState: true,
    emptyType: EmptyTemplatesStateTypes.NoTemplates,
  };
}
